import {
  AlertDialog,
  AlertDialogBody,
  AlertDialogContent,
  AlertDialogFooter,
  AlertDialogOverlay,
  Button,
  Spinner,
  Text,
} from '@chakra-ui/react';
import PropTypes from 'prop-types';
import React from 'react';
import { FaSync } from 'react-icons/fa';

const SyncDataModal = ({
  title,
  isOpen,
  onClose,
  SolidBTNText,
  loader,
  onClick,
}) => {
  return (
    <AlertDialog isOpen={isOpen} onClose={onClose} isCentered>
      <AlertDialogOverlay>
        <AlertDialogContent
          maxWidth="400px"
          borderRadius="lg"
          boxShadow="lg"
          p={4}
        >
          {/* <AlertDialogHeader
            fontSize="lg"
            fontWeight="medium"
            textAlign="center"
          >
            Confirm Deletion
          </AlertDialogHeader> */}
          <AlertDialogBody
            display="flex"
            flexDirection="column"
            alignItems="center"
            justifyContent="center"
            py={6}
          >
            <FaSync color="#fbb03b" size={60} mb={4} />
            <Text fontSize="18px" fontWeight="medium" textAlign="center" mt={5}>
              {title}
            </Text>
          </AlertDialogBody>
          <AlertDialogFooter justifyContent="center">
            <Button
              variant="outline"
              onClick={onClose}
              padding="10px 20px"
              mr={4}
            >
              Cancel
            </Button>
            <Button
              colorScheme="red"
              onClick={() => onClick()}
              padding="10px 20px"
              isDisabled={loader}
            >
              {loader ? <Spinner size="md" color="white" /> : SolidBTNText}
            </Button>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialogOverlay>
    </AlertDialog>
  );
};

SyncDataModal.propTypes = {
  title: PropTypes.string.isRequired,
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  SolidBTNText: PropTypes.string.isRequired,
  loader: PropTypes.bool,
  onClick: PropTypes.func.isRequired,
};

export default React.memo(SyncDataModal);
